// Languages offered to guests (guest app, online check-in, payment), each written in its
// own language. The dashboard itself stays in en / fr / es.
export const GUEST_LANGUAGES = [
  { code: 'fr', label: 'Français' },
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'de', label: 'Deutsch' },
  { code: 'it', label: 'Italiano' },
  { code: 'pt', label: 'Português' },
  { code: 'nl', label: 'Nederlands' },
  { code: 'da', label: 'Dansk' },
  { code: 'no', label: 'Norsk' },
  { code: 'pl', label: 'Polski' },
  { code: 'ru', label: 'Русский' },
  { code: 'tr', label: 'Türkçe' },
  { code: 'ca', label: 'Català' },
  { code: 'zh', label: '中文' },
];

export const GUEST_LANGUAGE_CODES = GUEST_LANGUAGES.map((l) => l.code);
export const DASHBOARD_LANGUAGE_CODES = ['en', 'fr', 'es'];
